import { createContext, useContext } from 'react';

import { ValidationType } from '../utils/ValidationType';

export type HeaderTitle = {
  title?: string;
  subtitle?: string;
};

export interface HeaderContextType {
  headerTitle: HeaderTitle | undefined;
  setHeaderTitle: (title: HeaderTitle) => void;
  triggerSubmit: (validationType: ValidationType) => void;
  setSubmit: (submit: (validationType: ValidationType) => void) => void;
  isFormLoading: boolean;
  setIsFormLoading: (loading: boolean) => void;
  formProgress: number;
  setFormProgress: (progress: number) => void;
  isFormSubmitted: boolean;
  setIsFormSubmitted: (submitted: boolean) => void;
}

export const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export const useHeaderContext = (): HeaderContextType => {
  const context = useContext(HeaderContext);
  if (context === undefined) {
    throw new Error('useHeaderContext must be used within a HeaderProvider');
  }
  return context;
};
